import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { getUser, userError, userLoaded } from "../actions/user.actions";
import { ProfileService } from "app/services/profile/profile.service";

@Injectable()
export class UserEffect {
  actions$ = inject(Actions);
  _router = inject(Router);
  private _accountService = inject(ProfileService);

  getUserInfos$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUser),
      mergeMap(() => {
        return this._accountService.getProfil().pipe(
          map((userInfos) => {
            return userLoaded({ userInfos });
          }),
          catchError((error) => of(userError({ error }))),
        );
      }),
    );
  });
}
